import { DomHelper, EventHelper } from '@bryntum/schedulerpro';
import { faBuilding } from '@fortawesome/pro-duotone-svg-icons';
import React, { useCallback, useMemo, useRef } from 'react';
// eslint-disable-next-line import/no-internal-modules
import { renderToStaticMarkup } from 'react-dom/server';
import { QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { LinkButton } from 'components/atoms/button';
import {
  EmptyState as EmptyStateAtom,
  EmptyStateIcon,
} from 'components/atoms/empty-state';
import { RoutePaths } from 'constant';
import { store } from 'data';
import { useIsCurrentUserCollaborator } from 'hooks/permissions';
import { useTranslation } from 'hooks/use-translation';
import { queryClient } from 'queries';
import { SchedulerReference } from '../types';

interface Props {
  schedulerRef: SchedulerReference;
}
export const useNoProjectsRender = ({
  schedulerRef,
}: Props): {
  showNoProjects: () => void;
} => {
  const { push } = useHistory();
  const isCollaborator = useIsCurrentUserCollaborator();

  const noResultDivRef = useRef<ReturnType<typeof DomHelper.createElement>>();
  const noResultMessage = useTranslation('projects.empty.message');
  const emptyCTA = useTranslation('projects.empty.cta', {
    a: (chunks) => <LinkButton>{chunks}</LinkButton>,
  });
  const noResultMessage1 = !isCollaborator ? emptyCTA : '';
  const title = useTranslation('projects.empty.title');
  const emptyState = useMemo(
    () => (
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <EmptyStateAtom
            image={<EmptyStateIcon icon={faBuilding} />}
            title={title}
            message={
              <>
                {noResultMessage}
                <br />
                <br />
                {noResultMessage1}
              </>
            }
          />
        </Provider>
      </QueryClientProvider>
    ),
    [noResultMessage, noResultMessage1, title],
  );
  const showNoProjects = useCallback(() => {
    if (noResultDivRef.current != null) {
      return;
    }
    const noResultDiv = DomHelper.createElement({
      tag: 'div',
      className: 'no-result',
      children: [
        {
          html: renderToStaticMarkup(emptyState),
        },
      ],
    });

    EventHelper.addListener(noResultDiv as HTMLElement, 'click', (event) => {
      const isButtonClick = event.target.closest('.ant-btn-link') != null;

      if (isButtonClick) {
        push(RoutePaths.projects);
      }
    });

    if (schedulerRef.current?.instance.subGrids.locked.element) {
      DomHelper.append(
        schedulerRef.current.instance.subGrids.locked.element,
        noResultDiv,
      );
    }

    noResultDivRef.current = noResultDiv;
  }, [emptyState, push, schedulerRef]);

  return {
    showNoProjects,
  };
};
